// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__WAm5D","square":"styles_square__2NVZm","rectangle":"styles_rectangle__x8H1A"};